import { liveavatar } from "@/lib/liveavatar/client";
import type { SessionDataAdapter } from "../sessionAdapter";

/**
 * LiveAvatar (Heygen) session data adapter. Mirrors the polling ladder
 * used previously inline in `SessionFrame.tsx`: session meta may lag
 * briefly after end, and the transcript API sometimes returns empty on
 * the first request even when data is available shortly after.
 */
export const liveavatarSessionAdapter: SessionDataAdapter = {
  async fetchSessionMeta(sessionId) {
    let sessionData: Record<string, unknown> | null = null;
    const delays = [0, 1500, 3000];
    for (const d of delays) {
      if (d) await new Promise((r) => setTimeout(r, d));
      try {
        const data = await liveavatar.getSession(sessionId);
        sessionData = data as Record<string, unknown>;
        if (data && Number((data as { duration?: number }).duration) > 0) break;
      } catch {
        /* retry */
      }
    }
    return sessionData;
  },
  async fetchTranscript(sessionId) {
    let transcript = await liveavatar.getSessionTranscript(sessionId).catch(() => null);
    if (!transcript?.transcript_data?.length) {
      await new Promise((r) => setTimeout(r, 1500));
      transcript = await liveavatar.getSessionTranscript(sessionId).catch(() => null);
    }
    if (!transcript) return null;
    return {
      session_active: transcript.session_active,
      next_timestamp: transcript.next_timestamp,
      transcript_data: (transcript.transcript_data ?? []).map((row) => ({
        role: row.role,
        transcript: row.transcript,
        absolute_timestamp: row.absolute_timestamp,
        relative_timestamp: row.relative_timestamp,
      })),
    };
  },
};